module.exports = __webpack_public_path__ + "static/media/viber.538aaefa.svg";